module.exports = __webpack_public_path__ + "img/route-interstate.8ae59bf0.svg";